import { apiRequest } from '@/core';
import { type User, type UserLogin } from '@/types';

export const loginRequest = async (user: UserLogin) =>
  apiRequest<User>({
    endpoint: 'login',
    body: user,
  });
